<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'resourceManagement-fabric',
  components: {
    PageTable,
  },
}
</script>
